import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import animated from 'animate.css'
import GLOBAL from './common/global.js'
import VueJsonp from 'vue-jsonp'
import axios from 'axios'
import { Cloud } from "@cyanmoon8/lfcloud";
import {
  PID,
  APP_SPLIT_KEY,
  APP_SPLIT_SECRET,
  TABLE_PREFIX,
} from "./config/constVariables.js";
import { lfRequest } from "./common/request.js"
Vue.use(VueJsonp)


console.log('APP_SPLIT_KEY====>>>>',APP_SPLIT_KEY)

axios.defaults.baseURL = GLOBAL.baseUrl; // 配置接口地址
Vue.prototype.$axios = axios;
Vue.prototype.$Cloud = new Cloud(
{
    pid: PID,
    app_split_key: APP_SPLIT_KEY,
    app_split_secret: APP_SPLIT_SECRET,
    table_prefix: TABLE_PREFIX,
  },
  lfRequest
);


// 参数：method（API名），data（请求参数对象）
Vue.prototype.jsp = function(method, data) {
	// baseUrl就是服务器地址
	const baseUrl = 'https://erp.lfwellness.cn/';
	let url = `${baseUrl}${method}?`;
	// jsonp请求参数和get方法类似，都是params的方式拼接
	for (let item in data) {
		url += `&${item}=${data[item]}`;
	}
	return this.$jsonp(url);
};

Vue.prototype.GLOBAL = GLOBAL;

Vue.use(animated)

Vue.use(require('vue-wechat-title')) //引入title插件

Vue.config.productionTip = false

Vue.filter('yearMonth', function() {
  const now = new Date()
  return now.getFullYear() + '年' + String(now.getMonth() + 1).padStart(2, '0') + '月'
})
//GEO
Vue.mixin({
	mounted() {
		this.addBreadcrumbSchema()
	},
	methods: {
		addBreadcrumbSchema() {
			// 根据当前路由 meta 生成面包屑数据
			const breadcrumbMap = {
				'/index': { name: '首页' },
				'/about-us': { name: '关于乐范', parent: '/index' },
				'/product': { name: '产品介绍', parent: '/index' },
				'/sales': { name: '销量TOP5', parent: '/index' },
				'/service': { name: '服务支持', parent: '/index' },
				'/shop': { name: '官方网店', parent: '/index' },
				'/policy': { name: '售后政策', parent: '/service' },
				'/question': { name: '产品视频', parent: '/product' },
				'/download': { name: 'App下载', parent: '/service' },
				'/relation': { name: '联系我们', parent: '/about-us' },
				'/hR': { name: '部位推荐', parent: '/product' },
				'/jointproduct': { name: '跨界联名', parent: '/product' },
				'/news': { name: '新闻资讯', parent: '/about-us' },
				'/Productstation': { name: '产品详情', parent: '/product' },
				'/faq': { name: '常见问题', parent: '/product' },
			}

			const path = this.$route.path
			const info = breadcrumbMap[path]
			if (!info) return

			// 构建面包屑列表
			const items = [{ name: '乐班官网', path: 'https://www.lfwellness.cn' }]

			if (info.parent) {
				const parentInfo = breadcrumbMap[info.parent]
				if (parentInfo) {
					items.push({ name: parentInfo.name, path: 'https://www.lfwellness.cn' + info.parent })
				}
			}

			items.push({ name: info.name, path: 'https://www.lfwellness.cn' + path })

			// 生成 Schema
			const schema = {
				"@context": "https://schema.org",
				"@type": "BreadcrumbList",
				"itemListElement": items.map((item, i) => ({
					"@type": "ListItem",
					"position": i + 1,
					"name": item.name,
					"item": item.path
				}))
			}

			const script = document.createElement('script')
			script.type = 'application/ld+json'
			script.id = 'breadcrumb-schema'
			// 避免重复注入
			const old = document.getElementById('breadcrumb-schema')
			if (old) old.remove()
			script.textContent = JSON.stringify(schema)
			document.head.appendChild(script)
		}
	}
})


new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
// 添加全局过滤器

